import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2yxkms7bg2hpm as _Result___get_isFailure__impl__jpiriv,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Companion_getInstance3m5wuix1ktvmf as Companion_getInstance } from '../../../../types-types-internal/kotools/types/internal/ErrorMessage.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { stringSerializer3fqetsvttr56r as stringSerializer } from '../../../../types-types-internal/kotools/types/internal/Serializers.mjs';
import {
  KSerializerzf77vz1967fq as KSerializer,
  DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { simpleNameOf1k8hddecfy128 as simpleNameOf } from '../../../../types-types-internal/kotools/types/internal/KClassX.mjs';
import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { serializationError3bsuwdsvfqinr as serializationError } from '../../../../types-types-internal/kotools/types/internal/Errors.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _NotBlankString___init__impl__za3uk1(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function NotBlankString__compareTo_impl_bsjd1d($this, other) {
  return compareTo(NotBlankString__toString_impl_5tex9r($this), NotBlankString__toString_impl_5tex9r(other));
}
function NotBlankString__compareTo_impl_bsjd1d_0($this, other) {
  return NotBlankString__compareTo_impl_bsjd1d($this.b2b_1, other instanceof NotBlankString() ? other.b2b_1 : THROW_CCE());
}
function NotBlankString__toString_impl_5tex9r($this) {
  return _get_value__a43j40($this);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      c2b(value) {
        return isBlank(value) ? null : _NotBlankString___init__impl__za3uk1(value);
      }
      d2b() {
        return NotBlankStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function NotBlankString__hashCode_impl_fxqzj4($this) {
  return getStringHashCode($this);
}
function NotBlankString__equals_impl_x41rss($this, other) {
  if (!(other instanceof NotBlankString()))
    return false;
  if (!($this === (other instanceof NotBlankString() ? other.b2b_1 : THROW_CCE())))
    return false;
  return true;
}
var NotBlankStringClass;
function NotBlankString() {
  if (NotBlankStringClass === VOID) {
    class $ {
      constructor(value) {
        this.b2b_1 = value;
      }
      e2b(other) {
        return NotBlankString__compareTo_impl_bsjd1d(this.b2b_1, other);
      }
      d(other) {
        return NotBlankString__compareTo_impl_bsjd1d_0(this, other);
      }
      toString() {
        return NotBlankString__toString_impl_5tex9r(this.b2b_1);
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.b2b_1);
      }
      equals(other) {
        return NotBlankString__equals_impl_x41rss(this.b2b_1, other);
      }
    }
    initMetadataForClass($, 'NotBlankString', VOID, VOID, [Comparable()], VOID, VOID, {0: NotBlankStringSerializer_getInstance});
    NotBlankStringClass = $;
  }
  return NotBlankStringClass;
}
function toNotBlankString(_this__u8e3s4) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    var tmp_0 = Companion_instance_0.c2b(_this__u8e3s4);
    var tmp0 = tmp_0 == null ? null : new (NotBlankString())(tmp_0);
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = Companion_getInstance().p2a();
        throw IllegalArgumentException().o2(toString(message));
      } else {
        tmp$ret$2 = tmp0.b2b_1;
        break $l$block;
      }
    }
    // Inline function 'kotlin.Companion.success' call
    var value = new (NotBlankString())(tmp$ret$2);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
var NotBlankStringSerializerClass;
function NotBlankStringSerializer() {
  if (NotBlankStringSerializerClass === VOID) {
    class $ {
      constructor() {
        NotBlankStringSerializer_instance = this;
        this.f2b_1 = stringSerializer(NotBlankStringDeserializationStrategy_getInstance());
      }
      b1n() {
        return this.f2b_1.b1n();
      }
      g2b(decoder) {
        return this.f2b_1.d1n(decoder).b2b_1;
      }
      d1n(decoder) {
        return new (NotBlankString())(this.g2b(decoder));
      }
      h2b(encoder, value) {
        this.f2b_1.c1n(encoder, new (NotBlankString())(value));
      }
      c1n(encoder, value) {
        return this.h2b(encoder, value instanceof NotBlankString() ? value.b2b_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'NotBlankStringSerializer', VOID, VOID, [KSerializer()]);
    NotBlankStringSerializerClass = $;
  }
  return NotBlankStringSerializerClass;
}
var NotBlankStringSerializer_instance;
function NotBlankStringSerializer_getInstance() {
  if (NotBlankStringSerializer_instance === VOID)
    new (NotBlankStringSerializer())();
  return NotBlankStringSerializer_instance;
}
function NotBlankStringDeserializationStrategy$descriptor$delegate$lambda() {
  // Inline function 'kotools.types.internal.simpleNameOf' call
  var simpleName = simpleNameOf(getKClass(NotBlankString()));
  var serialName = 'kotools.types.text.' + simpleName;
  return PrimitiveSerialDescriptor(serialName, STRING_getInstance());
}
function NotBlankStringDeserializationStrategy$_get_descriptor_$ref_5j9eg1() {
  return constructCallableReference((p0) => p0.b1n(), 1, 0, 21);
}
var NotBlankStringDeserializationStrategyClass;
function NotBlankStringDeserializationStrategy() {
  if (NotBlankStringDeserializationStrategyClass === VOID) {
    class $ {
      constructor() {
        NotBlankStringDeserializationStrategy_instance = this;
        var tmp = this;
        tmp.i2b_1 = lazy(NotBlankStringDeserializationStrategy$descriptor$delegate$lambda);
      }
      b1n() {
        var tmp0 = this.i2b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, NotBlankStringDeserializationStrategy$_get_descriptor_$ref_5j9eg1(), null);
        return tmp0.n3();
      }
      g2b(decoder) {
        // Inline function 'kotlin.Result.getOrNull' call
        var this_0 = toNotBlankString(decoder.n1r());
        var tmp = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
        var tmp0_elvis_lhs = tmp == null ? null : tmp.b2b_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (NotBlankString())(tmp_1)) == null) {
          serializationError(Companion_getInstance().p2a());
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
      d1n(decoder) {
        return new (NotBlankString())(this.g2b(decoder));
      }
    }
    initMetadataForObject($, 'NotBlankStringDeserializationStrategy', VOID, VOID, [DeserializationStrategy()]);
    NotBlankStringDeserializationStrategyClass = $;
  }
  return NotBlankStringDeserializationStrategyClass;
}
var NotBlankStringDeserializationStrategy_instance;
function NotBlankStringDeserializationStrategy_getInstance() {
  if (NotBlankStringDeserializationStrategy_instance === VOID)
    new (NotBlankStringDeserializationStrategy())();
  return NotBlankStringDeserializationStrategy_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  NotBlankString__hashCode_impl_fxqzj4 as NotBlankString__hashCode_impl_fxqzj418fmehvdt9fzl,
  NotBlankString__toString_impl_5tex9r as NotBlankString__toString_impl_5tex9r3bdt5aydt9d7j,
  Companion_instance_0 as Companion_instance1e7g2w4ksnnd,
  NotBlankString as NotBlankString2t6vf2scdbmna,
  toNotBlankString as toNotBlankString1ovj48s0kinvm,
};
//endregion

//# sourceMappingURL=NotBlankString.mjs.map
